import Event from "./Event";
import Cache from "./Cache";
import { objectToParams } from "../helpers/url";

class Book extends Event {
    constructor() {
        super();
        this.book = {};
        this.cacheDuration = 0; // seconds
        this.promises = {
            fetching: null,
        };
        this.setUpdatedd = Date.now();
        this.cache = new Cache();

        this.apiURL = "";
        if (process.env.NODE_ENV === "development") {
            this.apiURL = process.env.MIX_API_DEVELOPMENT
                ? process.env.MIX_API_DEVELOPMENT
                : "";
        } else {
            this.apiURL = process.env.MIX_API_PRODUCTION
                ? process.env.MIX_API_PRODUCTION
                : "";
        }
    }

    // Creating a global instance
    static createInstance() {
        return new this();
    }

    /**
     * Update timestamp
     */
    setUpdated() {
        this.setUpdatedd = Date.now();
    }

    /**
     * Fetch items from books
     *
     * Returns pending Promise if API request is pending or
     * returns cached data based on this.cacheDuration value
     *
     * @param {Object} filter - Object with query param names and values
     * @returns {Promise} Promise object with status and data
     */
    fetchBooks(params = "") {
        let status = null;
        this.publish("itemsFetching");

        // Book is cached
        let cachedBook = this.cache.get("book");
        if (cachedBook) return Promise.resolve(this.cache.get("book").data);

        this.promises.fetching = fetch(this.apiURL + "/book?" + params)
            .then((response) => {
                status = response.status;

                return response.text().then((text) => {
                    return {
                        status: response.status,
                        content: text,
                    };
                });
            })
            .then((response) => {
                let content =
                    response.status < 300 ? JSON.parse(response.content) : null;

                if (content) {
                    this.setUpdated();
                    this.book = content;
                    this.cache.set("book", this.cacheDuration, response);
                    this.publish("itemsFetched");
                }
                this.promises.fetching = null;

                return {
                    status: response.status,
                    content: content,
                };
            })
            .catch((error) => {
                this.setUpdated();
                this.promises.fetching = null;
                return {
                    status: 600,
                    error: error,
                };
            });

        return this.promises.fetching;
    }

    fetchFilters(params = "") {
        let status = null;
        this.publish("filtersFetching");

        this.promises.filtersFetching = fetch(this.apiURL + "/bookfilters?" + params)
            .then((response) => {
                status = response.status;

                return response.text().then((text) => {
                    return {
                        status: response.status,
                        content: text,
                    };
                });
            })
            .then((response) => {
                let content =
                    response.status < 300 ? JSON.parse(response.content) : null;

                if (content) {
                    this.setUpdated();
                    this.publish("filtersFetched");
                }
                this.promises.filtersFetching = null;

                return {
                    status: response.status,
                    content: content,
                };
            })
            .catch((error) => {
                this.setUpdated();
                this.promises.filtersFetching = null;
                return {
                    status: 600,
                    error: error,
                };
            });

        return this.promises.filtersFetching;
    }
}

export default Book;
